var MINIMUM_SCREEN_GUTTER = 16;
var DEFAULT_PLACEMENT_OPTIONS = {
  'top-centre': {
    horizontal: 'centre',
    isAboveTrigger: true,
    isLeftOfTrigger: false,
    vertical: 'top'
  },
  'top-start': {
    horizontal: 'left',
    isAboveTrigger: true,
    isLeftOfTrigger: false,
    vertical: 'top'
  },
  'top-end': {
    horizontal: 'right',
    isAboveTrigger: true,
    isLeftOfTrigger: false,
    vertical: 'top'
  },
  'right-center': {
    horizontal: 'right',
    isAboveTrigger: false,
    isLeftOfTrigger: false,
    vertical: 'centre'
  },
  'right-start': {
    horizontal: 'right',
    isAboveTrigger: false,
    isLeftOfTrigger: false,
    vertical: 'top'
  },
  'right-end': {
    horizontal: 'right',
    isAboveTrigger: false,
    isLeftOfTrigger: false,
    vertical: 'bottom'
  },
  'bottom-centre': {
    horizontal: 'centre',
    isAboveTrigger: false,
    isLeftOfTrigger: false,
    vertical: 'bottom'
  },
  'bottom-end': {
    horizontal: 'right',
    isAboveTrigger: false,
    isLeftOfTrigger: false,
    vertical: 'bottom'
  },
  'bottom-start': {
    horizontal: 'left',
    isAboveTrigger: false,
    isLeftOfTrigger: false,
    vertical: 'bottom'
  },
  'left-centre': {
    horizontal: 'left',
    isAboveTrigger: false,
    isLeftOfTrigger: true,
    vertical: 'centre'
  },
  'left-end': {
    horizontal: 'left',
    isAboveTrigger: false,
    isLeftOfTrigger: true,
    vertical: 'bottom'
  },
  'left-start': {
    horizontal: 'left',
    isAboveTrigger: false,
    isLeftOfTrigger: true,
    vertical: 'top'
  }
};
var DEFAULT_PLACEMENT_OPTION = 'bottom-start';

export { DEFAULT_PLACEMENT_OPTION, DEFAULT_PLACEMENT_OPTIONS, MINIMUM_SCREEN_GUTTER };
//# sourceMappingURL=Flyout.constants.js.map
